module.exports = __webpack_public_path__ + "img/K42-dr-congo.812c62de.png";